import React from "react";
import { Button } from "@mui/material";
import { FieldValues, useForm } from "react-hook-form";

import DocumentFormField from "./DocumentFormField";
import { DocumentFormFieldType } from "../../../types/document-management/document-management-types";

interface DocumentManagementFormProps {
  defaultValues: FieldValues;
  formFields: DocumentFormFieldType[];
  // Parent component defines type of form_values by fields & defaultValues
  handleFormSubmit: (form_values: any) => void;
  className?: string;
  loading?: boolean;
  confirmButtonText?: string;
  hideReset?: boolean;
}

const DocumentManagementForm: React.FC<DocumentManagementFormProps> = (props) => {
  const {
    defaultValues,
    formFields,
    handleFormSubmit,
    className = "",
    loading = false,
    confirmButtonText = "Submit",
    hideReset = false,
  } = props;

  const form = useForm({
    defaultValues,
  });

  const { handleSubmit, reset } = form;

  function onSubmit(data: FieldValues) {
    if (!loading) {
      handleFormSubmit(data);
    }
  }

  function handleReset() {
    reset();
    handleFormSubmit(defaultValues);
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} onReset={handleReset} className={className}>
      {formFields.map((field) => (
        <DocumentFormField key={field.id} field={field} form={form} />
      ))}
      {/* Modal Action Buttons */}
      <div className="form--footer flex justify-end items-center w-full gap-4">
        {!hideReset && (
          <Button variant="outlined" type="reset">
            Reset
          </Button>
        )}
        <Button variant="contained" type="submit">
          {loading ? (
            <div className="lds-ring lds-ring--white">
              <div></div>
            </div>
          ) : (
            confirmButtonText
          )}
        </Button>
      </div>
    </form>
  );
};

export default DocumentManagementForm;
